﻿import React, { useEffect, useId, useRef, useState } from 'react';
import styled from 'styled-components';

import definitions from '../../Style/LfStyleDefinitions';
import {mediaQuery} from '../../Style/cssHelpers';
import { Appear } from '../../UI/Appear';

const DEFAULT_ERROR_MESSAGE = 'Fältet måste fyllas i';

const ErrorMessage = (props) => {
    let errorMessage;
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const timeout = setTimeout(() => setVisible(true), 100)
        return () => clearTimeout(timeout)
    }, [setVisible])

    if (props.forId) {
        let validatedEl = document.getElementById(props.forId);
        errorMessage = typeof validatedEl.dataset.validationErrorMessage !== 'undefined'
            ? validatedEl.dataset.validationErrorMessage
            : DEFAULT_ERROR_MESSAGE;
    } else if (props.message) {
        errorMessage = props.message;
    } else {
        errorMessage = DEFAULT_ERROR_MESSAGE;
    }

    return (
        <Appear on={visible}>
            <ErrorSpan className="form-error is-visible">
                {errorMessage}
            </ErrorSpan>
        </Appear>
    );
}

export default ErrorMessage;

const ErrorSpan = styled.span`
    display: block;

    color: ${definitions.colors.error};
    line-height: 2.3; 
    
    font-size: 16px;
    ${mediaQuery.small(`
        font-size: 13px;
        padding: 5px 0px 10px 0px;
    `)}
`;